"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertAllegroNetlistToSchematic = convertAllegroNetlistToSchematic;
exports.getSchematicFromAllegroParseResult = getSchematicFromAllegroParseResult;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const AllegroTypes_1 = require("./AllegroTypes");
const AllegroUnconnectedPinNamingRule_1 = require("../../transformers/allegroOrchestratedTransformer/rules/AllegroUnconnectedPinNamingRule");
function convertAllegroNetlistToSchematic(netlist, partList, designId = 'allegro-netlist') {
    const innerResults = [];
    const partLookup = new Map();
    if (partList) {
        for (const part of partList.parts) {
            partLookup.set(part.refdes, { partName: part.partName, properties: part.properties });
        }
    }
    const moduleMap = new Map();
    for (const net of netlist.nets) {
        for (const node of net.nodes) {
            if (!moduleMap.has(node.refdes)) {
                const partInfo = partLookup.get(node.refdes);
                const transform = {
                    angle: 0,
                    mirrored: [false, false],
                };
                const module = {
                    ref: node.refdes,
                    footprintRef: partInfo?.properties['PACK_TYPE'] ?? partInfo?.partName ?? node.refdes,
                    componentRef: partInfo?.partName ?? node.refdes,
                    center: [0, 0],
                    layer: 'F',
                    transform,
                    name: node.refdes,
                    pinNets: {},
                    drawProperties: {},
                };
                if (partInfo?.properties['VALUE']) {
                    module.drawProperties['value'] = {
                        value: partInfo.properties['VALUE'],
                        hidden: true,
                    };
                }
                moduleMap.set(node.refdes, module);
            }
            const module = moduleMap.get(node.refdes);
            module.pinNets[node.pin] = net.name === 'NC' ? (0, AllegroUnconnectedPinNamingRule_1.unconnectedPinNetName)(node.refdes, node.pin) : net.name;
        }
    }
    const modules = Array.from(moduleMap.values());
    const nets = {};
    for (const net of netlist.nets) {
        if (net.name === 'NC') {
            for (const node of net.nodes) {
                const syntheticName = (0, AllegroUnconnectedPinNamingRule_1.unconnectedPinNetName)(node.refdes, node.pin);
                nets[syntheticName] = {
                    name: syntheticName,
                    connections: [
                        {
                            moduleRef: node.refdes,
                            moduleName: node.refdes,
                            pinRef: node.pin,
                        },
                    ],
                };
            }
            continue;
        }
        const connections = [];
        for (const node of net.nodes) {
            connections.push({
                moduleRef: node.refdes,
                moduleName: node.refdes,
                pinRef: node.pin,
            });
        }
        if (nets[net.name]) {
            innerResults.push({
                type: AllegroTypes_1.AllegroNetlistConversionMessageType.DuplicateNet,
                message: `Duplicate net name "${net.name}" — merging connections`,
                severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            });
            nets[net.name].connections.push(...connections);
        }
        else {
            nets[net.name] = {
                name: net.name,
                connections,
            };
        }
    }
    let title = 'Allegro Netlist Import';
    if (partList?.directives['ROOT_DRAWING']) {
        title = partList.directives['ROOT_DRAWING'];
    }
    const schematic = {
        modelType: 'schematic',
        designId,
        sourceFile: 'allegro-netlist',
        sheetIndex: 0,
        layerSet: 'default',
        drawings: {},
        edges_bbox: { minx: 0, miny: 0, maxx: 0, maxy: 0 },
        initial_zoombox: { minx: 0, miny: 0, maxx: 0, maxy: 0 },
        nets,
        modules,
        ports: {},
        metadata: {
            title,
            revision: '',
            company: '',
            date: partList?.directives['POST_TIME'] ?? new Date().toISOString().split('T')[0],
        },
        warnings: [],
    };
    const processingResults = {
        type: 'allegro-netlist-conversion',
        message: `Allegro netlist conversion completed with ${innerResults.length} diagnostic(s)`,
        innerResults,
    };
    (0, sigma_engine_shared_1.computeAggragateMessageResultSeverity)(processingResults);
    return { schematic, processingResults };
}
function getSchematicFromAllegroParseResult(parseResult, designId) {
    if (parseResult.processingResults.severity === sigma_engine_shared_1.BoundaryLevel.Error) {
        return undefined;
    }
    if (!parseResult.netlist.nets.length) {
        return undefined;
    }
    return convertAllegroNetlistToSchematic(parseResult.netlist, parseResult.partList, designId);
}
//# sourceMappingURL=allegroNetlistToSchematic.js.map